/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Box, FormControl, InputLabel, styled } from "@mui/material";
// import { Grid } from "@mui/material";
import { Stack } from "@mui/material";
import { FC, useState } from "react";
import DatePicker from "react-datepicker";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { toMoment } from "utils/DateTime";
import { Const } from "const";
import { DatePickerInput } from "./DatePickerInput";
import { theme } from "theme";

interface DateTimeInputProps {
  label?: string;
  date?: Date;
  disabled?: boolean;
  valid?: boolean;
  onDateTimeSelected?: (date: Date | null) => void;
}
export const DateTimeInput: FC<DateTimeInputProps> = ({
  label,
  date,
  disabled,
  valid,
  onDateTimeSelected,
}) => {
  const [selectedDate, setSelectedDate] = useState(date ?? new Date());
  return (
    <FormControl fullWidth>
      <Stack direction="row">
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <TimeInputContainer>
          <DatePicker
            selected={selectedDate}
            onChange={(d, e) => {
              if (d !== null) {
                setSelectedDate(d);
                onDateTimeSelected?.(d);
              }
            }}
            startDate={selectedDate}
            disabled={disabled}
            customInput={<DatePickerInput valid={valid} />}
            wrapperClassName="custom-datepicker-wrapper"
          />
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DesktopTimePicker
              value={toMoment(selectedDate)}
              ampm={false}
              timeSteps={Const.taskStartTimeInputStep}
              onChange={(d, e) => {
                if (d !== null) {
                  setSelectedDate(d.toDate());
                  onDateTimeSelected?.(d.toDate());
                }
              }}
              sx={{
                width: "100px",
                minWidth: 110,
                backgroundColor: valid ? "white" : theme.palette.error.main,
              }}
              disabled={disabled}
            />
          </LocalizationProvider>
        </TimeInputContainer>
      </Stack>
    </FormControl>
  );
};

const TimeInputContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  gap: theme.spacing(1, 1),
}));
